import API, { graphqlOperation } from "@aws-amplify/api";
import { ordersByClientCreatedAt } from "../graphql/queries";
import _ from "lodash";

/**
 * Get order by client package id
 * Pulls all order for a clientId and then filters by the packageId
 * @param {string} clientId - client id
 * @param {string} pkgId - package id
 * @returns {object} order
 */
export const getOrderByClientPackageId = async (clientId, pkgId) => {
  const response = await API.graphql(
    graphqlOperation(ordersByClientCreatedAt, {
      clientId: clientId,
    })
  );
  console.log("getOrderByClientPackageId", response);
  return _.find(
    response.data.ordersByClientCreatedAt.items,
    (order) =>
      _.get(order, "clientpackage") &&
      _.get(order, "clientpackage.id") === pkgId
  );
};
